import { render, staticRenderFns } from "./CurrentUserFlags.vue?vue&type=template&id=10a5e534"
import script from "./CurrentUserFlags.vue?vue&type=script&lang=ts"
export * from "./CurrentUserFlags.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports